import { useGoogleMapsLibraries } from 'common/google-map-context';
import useConfig from 'hooks/use-config';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import googleMapWidget from '../google-map-widget';
import useIsMobile from 'hooks/use-is-mobile';
import { useRefreshMap } from './use-refresh-map';
import { useOnSpot } from './use-on-spot';
export const useWidget = ({ mapWidgetRef, mapContainerRef, centerLatLng, // in a few places
zoom, // This is state on SpotMap - not in redux
showAllSpots, // is for Airport only - maybe worth rethinking
spots, // Is transformed in spotMap -  not in redux
onSpotDetailCallback, // Look into if this drilling is needed
onGoogleMapLoaded, // Look into if this drilling is needed
onZoom, // Look into if this drilling is needed
onPan, // Look into if this drilling is needed
 }) => {
    const { googleMapsId } = useConfig();
    const { googleMapsLoaded } = useGoogleMapsLibraries();
    const destinationTitle = useSelector((state) => state.destination.data.title // Need to type
    );
    const kmlMapLayerEnabled = useSelector(
    // @ts-expect-error - to be reviewed MR 9/25/25
    (state) => state.search.data.kmlMapLayerEnabled // Maybe deprecated
    );
    const kmlMapLayerURL = useSelector(
    // @ts-expect-error - to be reviewed MR 9/25/25
    (state) => state.search.data.kmlMapLayerURL // Maybe deprecated
    );
    const highlightedSpotId = useSelector((state) => state.spots.highlightedSpotId);
    const previewedSpotId = useSelector((state) => state.spots.previewedSpotId);
    const activeRatingTypes = useSelector((state) => state.filters.activeRatingTypes);
    const isMobile = useIsMobile();
    const refreshMap = useRefreshMap({
        mapWidgetRef,
        centerLatLng,
        spots,
        zoom,
    });
    const { onSpotDetail, onSpotHighlighted, onSpotPreviewed } = useOnSpot({
        onSpotDetailCallback, // Look into if this drilling is needed
    });
    // initialize Google Map Widget
    useEffect(() => {
        if (googleMapsLoaded &&
            !mapWidgetRef.current &&
            mapContainerRef.current) {
            mapWidgetRef.current = googleMapWidget({
                container: mapContainerRef.current,
                googleMapsId,
                zoom,
                centerLatLng,
                centerTitle: destinationTitle,
                kmlMapLayerEnabled,
                kmlMapLayerURL,
                showAllSpots,
                isMobile,
                highlightedSpotId,
                previewedSpotId,
                onPan,
                onSpotDetail,
                onZoom,
                onGoogleMapLoaded,
                onSpotHighlighted,
                onSpotPreviewed,
                ratingFilters: activeRatingTypes,
            });
        }
        if (mapWidgetRef.current) {
            refreshMap();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        googleMapsLoaded,
        googleMapsId,
        centerLatLng,
        destinationTitle,
        kmlMapLayerEnabled,
        kmlMapLayerURL,
        onGoogleMapLoaded,
        onSpotDetail,
        onZoom,
        zoom,
        showAllSpots,
        onSpotPreviewed,
        refreshMap,
        highlightedSpotId,
        isMobile,
        onSpotHighlighted,
        previewedSpotId,
        activeRatingTypes,
        onPan,
    ]);
    // unmount cleanup
    useEffect(() => {
        return () => {
            mapWidgetRef.current?.cleanup();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
